import { ActionKeys } from './constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const saveFilterGroup = (filterGroupName: string, filters: any) =>
  <const>{
    payload: {
      filterGroupName,
      filters,
    },
    type: ActionKeys.FILTER_SAVE_FILTER_GROUP,
  };

export const saveFilterGroupSuccess = (data) =>
  <const>{
    payload: {
      data,
    },
    type: ActionKeys.FILTER_SAVE_FILTER_GROUP_SUCCESS,
  };

export const saveFilterGroupError = (errorMessage: string) =>
  <const>{
    payload: {
      errorMessage,
    },
    type: ActionKeys.FILTER_SAVE_FILTER_GROUP_ERROR,
  };

export const getFilterGroups = () =>
  <const>{
    type: ActionKeys.FILTER_GET_FILTER_GROUPS,
  };

export const getFilterGroupsSuccess = (data) =>
  <const>{
    payload: {
      data,
    },
    type: ActionKeys.FILTER_GET_FILTER_GROUPS_SUCCESS,
  };

export const getFilterGroupsError = (errorMessage: string) =>
  <const>{
    payload: {
      errorMessage,
    },
    type: ActionKeys.FILTER_GET_FILTER_GROUPS_ERROR,
  };

export const deleteFilterGroup = (filterGroupObjectID: string) =>
  <const>{
    payload: {
      filterGroupObjectID,
    },
    type: ActionKeys.FILTER_DELETE_FILTER_GROUP,
  };

export const deleteFilterGroupSuccess = () =>
  <const>{
    type: ActionKeys.FILTER_DELETE_FILTER_GROUP_SUCCESS,
  };

export const deleteFilterGroupError = (errorMessage: string) =>
  <const>{
    payload: {
      errorMessage,
    },
    type: ActionKeys.FILTER_DELETE_FILTER_GROUP_ERROR,
  };

export const showNewTab = () =>
  <const>{
    type: ActionKeys.FILTER_SHOW_NEW_TAB,
  };

export const hideNewTab = () =>
  <const>{
    type: ActionKeys.FILTER_HIDE_NEW_TAB,
  };

export const changeTabShown = (tabName: string) =>
  <const>{
    payload: {
      tabName,
    },
    type: ActionKeys.FILTER_CHANGE_TAB,
  };

export const changeTabShownSuccess = (tabName: string) =>
  <const>{
    payload: {
      tabName,
    },
    type: ActionKeys.FILTER_CHANGE_TAB_SUCCESS,
  };

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const saveTempFilterGroup = (filters: any) =>
  <const>{
    payload: {
      filters,
    },
    type: ActionKeys.FILTER_SAVE_TEMP_GROUP,
  };

export type FiltersActions =
  | ReturnType<typeof changeTabShown>
  | ReturnType<typeof changeTabShownSuccess>
  | ReturnType<typeof deleteFilterGroup>
  | ReturnType<typeof deleteFilterGroupError>
  | ReturnType<typeof deleteFilterGroupSuccess>
  | ReturnType<typeof getFilterGroups>
  | ReturnType<typeof getFilterGroupsError>
  | ReturnType<typeof getFilterGroupsSuccess>
  | ReturnType<typeof hideNewTab>
  | ReturnType<typeof saveFilterGroup>
  | ReturnType<typeof saveFilterGroupError>
  | ReturnType<typeof saveFilterGroupSuccess>
  | ReturnType<typeof saveTempFilterGroup>
  | ReturnType<typeof showNewTab>;
